// Sisällön päivitys ylläpitäjälle (Passi → Ylläpito). Uudet ja päivitetyt reitit, kohteet ja kokoelmat tulevat
// palvelimen sisältöpaketeista (backend/app/content_pack.py), joten niiden lisääminen ei vaadi uutta sovellusversiota:
// tiedosto palvelimelle, tästä painike, ja puhelimet saavat uuden sisällön seuraavalla päivityksellä.

import { useEffect, useState } from "preact/hooks";

import { countsText, reportLines } from "../lib/contentAdmin.js";
import { PoiCreateSheet } from "./PoiCreateSheet.jsx";
import { RouteImportSheet } from "./RouteImportSheet.jsx";

export function ContentAdminCard({ app }) {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(false);
  const [busy, setBusy] = useState(false);
  const [report, setReport] = useState(null);
  const [routeSheet, setRouteSheet] = useState(false); // "Lisää reitti GPX:stä" -arkki
  const [poiSheet, setPoiSheet] = useState(false); // "Lisää kohde tähän" -arkki

  useEffect(() => {
    if (!app.admin) return undefined;
    let alive = true;
    app.api.adminContent().then(
      (data) => alive && setStatus(data),
      () => alive && setError(true),
    );
    return () => {
      alive = false;
    };
  }, [app.admin]);

  const reload = async () => {
    setBusy(true);
    setError(false);
    try {
      const result = await app.api.adminContentReload();
      setReport(result);
      setStatus(result.status);
      app.refresh(); // oma lista päivittyy heti
    } catch {
      setError(true);
    } finally {
      setBusy(false);
    }
  };

  const problems = status?.problems ?? [];
  return (
    <section class="content-admin" aria-label="Sisältö">
      <h2>Sisältö</h2>
      {error && <p class="rec-note warn" role="alert">Palvelin ei vastannut. Yritä uudelleen.</p>}
      {!status && !error && <p class="s">Haetaan…</p>}
      {status && (
        <p class="s">
          {countsText(status.counts)}. Tiedostot: {status.files.join(", ")}.
          {!status.content_dir_set && " Lisäpakettien hakemistoa ei ole asetettu palvelimella."}
        </p>
      )}
      {problems.length > 0 && (
        <ul class="content-problems" role="alert">
          {problems.map((p) => <li key={p}>Ohitettu: {p}</li>)}
        </ul>
      )}
      <div class="sheet-actions">
        <button class="btn" disabled={busy} onClick={reload}>{busy ? "Ladataan…" : "Lataa sisältö uudelleen"}</button>
        <button class="btn" onClick={() => setRouteSheet(true)}>Lisää reitti GPX:stä</button>
        <button class="btn" onClick={() => setPoiSheet(true)}>Lisää kohde tähän</button>
      </div>
      {poiSheet && (
        <PoiCreateSheet
          app={app}
          onClose={() => setPoiSheet(false)}
          // Uusi kohde kirjoitettiin pakettiin ja sisältö ladattiin palvelimella: päivitä tila.
          onSaved={() => app.api.adminContent().then(setStatus, () => {})}
        />
      )}
      {routeSheet && (
        <RouteImportSheet
          app={app}
          onClose={() => setRouteSheet(false)}
          // Uusi reitti kirjoitettiin pakettiin ja sisältö ladattiin palvelimella: päivitä tila ja oma lista.
          onSaved={() => app.api.adminContent().then(setStatus, () => {})}
        />
      )}
      {report && (
        <ul class="content-report" aria-live="polite">
          {reportLines(report)
            .filter((l) => !l.text.startsWith("Ohitettu:")) // ongelmat näytetään jo yllä
            .map((l) => <li key={l.text} class={l.tone}>{l.text}</li>)}
        </ul>
      )}
    </section>
  );
}
